import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";
import { PrinterOutlined, ArrowLeftOutlined, DownloadOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import CustomerDueFilters from "./components/CustomerDueFilters";
import CustomerDueTable from "./components/CustomerDueTable";
// import ReportDom from "../../components/common/ReportDom";
import ReportDom from "../../../components/common/ReportDom";
import { resetReport, searchCustomers } from "./customerDueSlice";
import { selectAuthInfo } from "../../Auth/authSelectors";
import { exportCustomerDueReportCsv } from "./components/exportCustomerDueReportCsv";

const { Title } = Typography;

const CustomerDueReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const authInfo = useSelector(selectAuthInfo);
  const reportRef = useRef();
  const { report } = useSelector((state) => state.customerDueReport);
  useEffect(() => {
   if (authInfo) {
     dispatch(searchCustomers({ query: "" }));
    }
  }, [dispatch, authInfo]);

  const handleNavigateToReports = () => {
    navigate("/reports");
    dispatch(resetReport());
  };

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Customer Due Invoice Wise Report",
    removeAfterPrint: true,
  });
 const handleDownloadCsv = () => {
    exportCustomerDueReportCsv({
      report,
      authInfo,
      title:    "Customer Due Invoice Wise Report",
      filename: "customer_due_invoice_wise",
    });
  };

  const hasData = report.length > 0;
  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={handleNavigateToReports}
                style={{ marginRight: 8 }}
              />
              <Title level={4} style={{ margin: 0 }} className="reportBigTitle" >Customer Due Invoice Wise Report</Title>
            </div>
          }
         extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <CustomerDueFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <CustomerDueTable authInfo={authInfo} />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Customer Due Invoice Wise Report"
          mode="report-page"
          renderTable={() => (
            <CustomerDueTable printMode={true} authInfo={authInfo} />
          )}
        />
      </div>
    </div>
  );
};

export default CustomerDueReport;